<ng-container
	*ngFor="let textItem of parameterizedHtmlTextItems"
	[ngSwitch]="textItem.valueType"
>
  <!-- String Type	-->
	<span *ngSwitchCase="parameterizedHtmlTextValueTypeEnum.STRING">{{ textItem.value }}</span>

	<!-- TemplateRef Type	-->
	<ng-container
		*ngSwitchCase="parameterizedHtmlTextValueTypeEnum.TEMPLATE_REF"
		[ngTemplateOutlet]="textItem.value"
	></ng-container>
</ng-container>
